import { ExpandMoreOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

const Benefits = () => {
  const [expandedPanel, setExpandedPanel] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <div className="mx-3 my-4 flex flex-col">
      <Accordion
        expanded={expandedPanel === "inpatientCare"}
        onChange={handleChange("inpatientCare")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Inpatient care
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <div className="ml-2">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  Room and board accommodation
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Use of Operating Room, Intensive Care Unit (ICU), Isolation
                  Room and Recovery Room
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Professional fees of attending physicians, surgeons,
                  anesthesiologist and Cardio-pulmonary Specialist (for
                  clearance before surgery and cardiac monitoring during
                  surgery)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Standard nursing services
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Medicines for inpatient care
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Blood product transfusions and intravenous (IV) fluids
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  X-ray, laboratory examinations, diagnostic tests and
                  therapeutic procedures incidental to confinement
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Dressings, conventional casts (plaster of Paris) and sutures
                </Typography>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "outpatientCare"}
        onChange={handleChange("outpatientCare")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Outpatient care
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <div className="ml-2">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  X-ray, laboratory examinations, routine, diagnostic and
                  therapeutic procedures
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Consultations
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Treatment of minor injuries
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Eye laser therapy for retinal tear / hole / detachment and
                  glaucoma
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Cauterization of warts
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Sclerotherapy (for varicose veins)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Speech therapy (For stroke patients only)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Allergy testing
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Tuberculin test
                </Typography>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "preventiveCare"}
        onChange={handleChange("preventiveCare")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Preventive care
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <Typography variant="body2" color="textSecondary">
            Passive and active vaccines for treatment of tetanus and animal
            bites
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "emergencyCare"}
        onChange={handleChange("emergencyCare")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Emergency care
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <Typography variant="body2" color="textSecondary">
            Any life-threatening or unexpected onset of a condition or illness,
            which requires the immediate alleviation of pain or discomfort
            within 24 hours including confinement in a regular private room.
          </Typography>

          <div className="mt-2">
            <div className="font-semibold text-[#1F2328]">
              Affiliated Hospital
            </div>

            <div className="ml-2">
              <ul
                style={{
                  padding: 0,
                  margin: 0,
                  listStyleType: "disc",
                  marginLeft: "1em",
                }}
                className="mt-2"
              >
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Doctor’s services
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Consultations
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Emergency room fees
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Medicines used for immediate relief and during treatment
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Oxygen, intravenous (IV) fluids and blood products
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    Dressings, conventional casts (plaster of Paris) and sutures
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" color="textSecondary">
                    X-rays, laboratory, diagnostic examinations and other
                    medical services related to the emergency treatment of the
                    patient
                  </Typography>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <div className="font-semibold text-[#1F2328]">
              Non-Affiliated Hospital
            </div>

            <div className="mt-1">
              <div className="text-sm font-semibold text-[#1F2328]">
                Within the Philippines
              </div>

              <div className="ml-2">
                <ul
                  style={{
                    padding: 0,
                    margin: 0,
                    listStyleType: "disc",
                    marginLeft: "1em",
                  }}
                  className="mt-2"
                >
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Reimbursement up to 80% of the actual hospital bills and
                      80% of the Professional fees (based on Maxicare rates)
                      incurred during the first twenty-four (24) hours of
                      treatment up to ₱30,000.00 / availment / member.
                    </Typography>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-2">
              <div className="text-sm font-semibold text-[#1F2328]">
                Areas without accredited hospitals within the Philippines
              </div>

              <div className="ml-2">
                <ul
                  style={{
                    padding: 0,
                    margin: 0,
                    listStyleType: "disc",
                    marginLeft: "1em",
                  }}
                  className="mt-2"
                >
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Reimbursement of 100% of the total hospital bills and
                      Professional fees (based on Maxicare rates)
                    </Typography>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-2">
              <div className="text-sm font-semibold text-[#1F2328]">
                Outside the Philippines
              </div>

              <div className="ml-2">
                <ul
                  style={{
                    padding: 0,
                    margin: 0,
                    listStyleType: "disc",
                    marginLeft: "1em",
                  }}
                  className="mt-2"
                >
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Maxicare shall reimburse 100% actual costs up to
                      ₱30,000.00 / availment / member
                    </Typography>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-2">
              <div className="text-sm font-semibold text-[#1F2328]">
                Ambulance Service up to ₱2,500.00 per conduction
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "additionalBenefits"}
        onChange={handleChange("additionalBenefits")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Additional benefits
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <div className="ml-2">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  Life coverage with Accidental Death & Dismemberment
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Scoliosis treatment
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Congenital illness
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Consultations for Chronic Dermatoses up to Benefit Limit
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Transurethral Microwave Therapy of Prostate
                </Typography>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "ACU"}
        onChange={handleChange("ACU")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Annual Check-Up (ACU) - Available to all plan types
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <Typography variant="body2" color="textSecondary">
            Clinic-based Annual Check-Up, consist of five (5) basic routines:
          </Typography>

          <div className="ml-2 mt-1">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  History and physical exam
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  CBC (Complete Blood Count)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Routine Urinalysis
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Routine Fecalysis
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Chest x-ray (PA and lateral)
                </Typography>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "dentalCare"}
        onChange={handleChange("dentalCare")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Dental care (optional)
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <div className="ml-2">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  Annual Oral / Dental Examination and Consultation
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Emergency Dental Treatment
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Annual Oral Prophylaxis
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Simple Tooth Extractions
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Restorative and Prosthodontic Treatment Planning
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Permanent fillings
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Unlimited temporary fillings, as needed
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Desensitization of hypersensitive teeth twice a year
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Simple adjustment of dentures
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Recementation of loose crowns, inlays or onlays
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Dental nutrition and Dietary counseling
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Dental Health Education
                </Typography>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "maxicareProgram"}
        onChange={handleChange("maxicareProgram")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Maxicare’s international assist program
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <div className="ml-2">
            <ul
              style={{
                padding: 0,
                margin: 0,
                listStyleType: "disc",
                marginLeft: "1em",
              }}
            >
              <li>
                <Typography variant="body2" color="textSecondary">
                  24-hour Telephone Medical Advice
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Emergency Medical Evacuation
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Emergency Medical Repatrition
                </Typography>
              </li>
              <li>
                <Typography variant="body2" color="textSecondary">
                  Repatrition of Mortal Remains
                </Typography>
              </li>
            </ul>

            <div className="w-full flex flex-row mt-2">
              <div className="w-full text-xs italic">
                This is in partnership with Assist America. Visit their website{" "}
                <a
                  href="https://www.assistamerica.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0947AB] font-semibold"
                >
                  www.assistamerica.com
                </a>{" "}
                for more information
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        className="mt-2"
        expanded={expandedPanel === "dreadedDisease"}
        onChange={handleChange("dreadedDisease")}
        variant="outlined"
        sx={{
          boxShadow: "none",
          borderRadius: "8px",
          "&:first-of-type": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          },
          "&::before": {
            background: "none",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
          <div className="text-sm text-[#1F2328] font-semibold">
            Dreaded disease / condition
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ borderTop: "1px solid #E3E4E5" }}>
          <Typography variant="body2" color="textSecondary">
            This corresponds to any condition that is considered to be chronic,
            progressive, life-threatening and which may entail lifelong therapy.
            This also refers to conditions where complete cure cannot be
            ensured.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Benefits;
